import { isArray } from 'lodash'
import { REGISTER_COLUMNS } from '@src/constants'
import { Mkb10InputWithState } from '@src/modules/monitoring/components/Mkb10Input/Mkb10InputWithState'
import { RegisterColumn } from './RegisterColumn'

export class DiagListColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.DIAG_LIST

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Диагноз (МКБ-10)',
        component: Mkb10InputWithState,
        defaultValue: [],
      },
      width: 500,
      dataIndex: 'diag_list',
      dataRender: diag_list => isArray(diag_list) ? diag_list.join(', ') : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters }) {
    let diag_list = filters?.[this.type]?.length ? filters?.[this.type] : undefined

    return {
      args: {
        diag_list,
      },
    }
  }
}
